import { Autocomplete, Box, Button, Grid, IconButton, InputAdornment, Paper, autocompleteClasses } from '@mui/material';
import { CustomListBox2Styled, CustomListStyled, PageStyled } from './index.styles';
import CustomInput, { CustomDatePicker } from 'components/Input';
import { useTranslation } from 'react-i18next';

import { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';

import { SwapHoriz, Search, ArrowForward, Close, Event, LocationOn, CheckCircle } from '@mui/icons-material';
import moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/de';

import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import i18n from 'assets/i18n';
import { useMediaScreen } from 'common/theme/media';
import { deleteBusInfo, setBusInfo } from 'store/reducers/busReducer';
import useBusService from 'services/bus/index.api';
import { BusUrlGenerator } from 'common/utils';

interface filterDataFromToInterface {
    label: string;
    code: string;
    id: string;
}
interface BusSearchBarProps {
    showDetail?: boolean;
    data?: any;
    from?: string;
    to?: string;
    busSelection?: boolean;
    gtm?: string; // Google Tag Manager
}

interface filterDataInterface {
    from: filterDataFromToInterface;
    to: filterDataFromToInterface;
    departureDate: string; // Gidiş Tarihi
}
export interface busUrlInterface {
    from?: string;
    to?: string;
    date?: string;
}

const BusSearchBar = ({ gtm = 'undefined', showDetail, data }: BusSearchBarProps) => {
    const media = useMediaScreen();

    const { search, searchPopularCities } = useBusService();
    const [focusIndex, setFocusIndex] = useState<number>(0);

    const handleFocusOutFunc = (data: any) => {
        let from = Boolean(data.from.label);
        let to = Boolean(data.to.label);
        let departureDate = Boolean(data.departureDate);
        let returnDate = data.isOneWay === 1 ? true : Boolean(data.returnDate);

        const tempArray = [
            { value: from, index: 1 },
            { value: to, index: 2 },
            { value: departureDate, index: 3 },
            { value: returnDate, index: 4 },
        ];
        const result = tempArray.find((item: any) => item.value === false);
        result ? setFocusIndex(result.index) : setFocusIndex(0);
    };

    const [dateButtonIndex, setDateButtonIndex] = useState<number | undefined>(0);

    const [cities, setCities] = useState<any>([]);
    const { t } = useTranslation();
    const [fromData, setFromData] = useState<any>([]);
    const [toData, setToData] = useState<any>([]);
    const [filterData, setFilterData] = useState<filterDataInterface>(
        data
            ? data
            : {
                  from: {
                      label: '',
                      code: '',
                      id: '',
                  },
                  to: {
                      label: '',
                      code: '',
                      id: '',
                  },
                  date: '',
              }
    );
    const currentFilterData = useSelector((state: any) => state.bus.filterHistoryBus);

    const dispatch = useDispatch();

    const getSearch = useCallback(async (type: string, text: string) => {
        if (text.length >= 3) {
            try {
                const response = await search(text);

                let tempDataList: any = [];
                const data = response.data.hits.hits ? response.data.hits.hits : [];

                data.forEach((item: any) => {
                    const tempData = {
                        label: `${item._source.StopName}`,
                        code: `${item._source.ID}`,
                        id: item._id,
                    };
                    tempDataList.push(tempData);
                });

                if (type === 'start') {
                    setFromData(tempDataList);
                } else {
                    setToData(tempDataList);
                }
            } catch (error) {
                console.log(error);
            }
        } else {
            if (type === 'start') {
                setFromData([]);
            } else {
                setToData([]);
            }
        }
    }, []);

    const sendSearch = () => {
        const tempData = {
            from: filterData.from.code,
            to: filterData.to.code,
            date: filterData.departureDate.replaceAll('-', ''),
        } as busUrlInterface;

        setTimeout(() => {
            dispatch(setBusInfo(filterData));
        });
        setTimeout(() => {
            window.location.href = BusUrlGenerator(tempData);
        });
    };

    const CustomListBox = (props: any) => {
        return (
            <CustomListStyled>
                <Paper elevation={8} sx={{ mt: 1 }} {...props} />
            </CustomListStyled>
        );
    };
    const CustomListBox2 = (type: string) => {
        return (
            <CustomListBox2Styled>
                <Paper elevation={8} sx={{ mt: 1 }}>
                    <div className="last-search-area">
                        {currentFilterData.filter((item: any) => {
                            return item.departureDate >= moment(new Date()).format('YYYY-MM-DD');
                        }).length > 0 && (
                            <>
                                <div className="title">{t(`bus.widgets.searchBar.lastSearchText`)}</div>
                                {currentFilterData
                                    .filter((item: any) => {
                                        return item.departureDate >= moment(new Date()).format('YYYY-MM-DD');
                                    })
                                    .slice(0, 2)
                                    .map((item: any, index: any) => {
                                        return (
                                            <div className="cardArea" key={index}>
                                                <div className="closeButton">
                                                    <IconButton
                                                        onMouseDown={() => {
                                                            dispatch(deleteBusInfo(index));
                                                        }}
                                                    >
                                                        <Close color="disabled" fontSize="small" />
                                                    </IconButton>
                                                </div>
                                                <div
                                                    className="card"
                                                    key={index}
                                                    onMouseDown={() => {
                                                        formik.setErrors({});
                                                        formik.setTouched({});

                                                        formik.setFieldValue('from', item.from);
                                                        formik.setFieldValue('to', item.to);
                                                        formik.setFieldValue('departureDate', item.departureDate);

                                                        if (
                                                            moment(item.departureDate).format('YYYY-MM-DD') !==
                                                            moment(new Date()).format('YYYY-MM-DD')
                                                        ) {
                                                            if (
                                                                moment(new Date())
                                                                    .add(1, 'days')
                                                                    .format('YYYY-MM-DD') ===
                                                                moment(item.departureDate).format('YYYY-MM-DD')
                                                            ) {
                                                                setDateButtonIndex(1);
                                                            } else if (
                                                                moment(item.departureDate).format('YYYY-MM-DD') ===
                                                                moment(new Date()).format('YYYY-MM-DD')
                                                            ) {
                                                                setDateButtonIndex(0);
                                                            } else {
                                                                setDateButtonIndex(undefined);
                                                            }
                                                        } else {
                                                            if (
                                                                moment(item.departureDate).format('YYYY-MM-DD') ===
                                                                moment(new Date()).format('YYYY-MM-DD')
                                                            ) {
                                                                setDateButtonIndex(0);
                                                            }
                                                        }

                                                        setFilterData(item);
                                                    }}
                                                >
                                                    <div className="cardContent">
                                                        <div className="leftCard">
                                                            {item.from.label}
                                                            <ArrowForward color="secondary" /> {item.to.label}
                                                        </div>
                                                    </div>
                                                    <div className="cardInfo">
                                                        <div>
                                                            {' '}
                                                            <Event className="event-icon" color="primary" />
                                                            {moment(item.departureDate)
                                                                .locale(i18n.language)
                                                                .format('DD MMM YYYY dddd')}
                                                            {item.returnDate &&
                                                                ' - ' +
                                                                    moment(item.returnDate)
                                                                        .locale(i18n.language)
                                                                        .format('DD MMM YYYY dddd')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </>
                        )}
                        <div className="title">{t(`bus.widgets.searchBar.popularCityText`)}</div>
                        <div className="cities-buttons">
                            <div>
                                {cities.map((item: any, index: any) => {
                                    return (
                                        <Button
                                            key={index}
                                            color="primary"
                                            variant="outlined"
                                            onMouseDown={() => {
                                                if (type === 'start') {
                                                    getSearch('start', item.label);
                                                    setFilterData({
                                                        ...filterData,
                                                        from: item,
                                                    });
                                                    formik.setFieldValue('from', item);
                                                    setTimeout(() => {
                                                        handleFocusOutFunc({
                                                            ...filterData,
                                                            from: item,
                                                        });
                                                    });
                                                } else {
                                                    getSearch('end', item.label);
                                                    setFilterData({
                                                        ...filterData,
                                                        to: item,
                                                    });
                                                    formik.setFieldValue('to', item);
                                                    setTimeout(() => {
                                                        handleFocusOutFunc({
                                                            ...filterData,
                                                            to: item,
                                                        });
                                                    });
                                                }
                                            }}
                                        >
                                            {item.label}
                                        </Button>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </Paper>
            </CustomListBox2Styled>
        );
    };

    const CustomList = (props: any, option: any) => {
        return (
            <CustomListStyled>
                <Box component="li" {...props}>
                    <span>{option.label}</span>
                </Box>
            </CustomListStyled>
        );
    };

    const fromToChange = useCallback((data: any) => {
        if (data.to.label && data.from.label) {
            setFilterData({
                ...filterData,
                from: data.to,
                to: data.from,
                departureDate: data.departureDate,
            });
            setFromData([data.to]);
            setToData([data.from]);
        }
    }, []);

    const handleAutocompleteChange1 = (event: any, value: any) => {
        formik.setFieldValue('from', value);
        setFilterData({
            ...filterData,
            from: value,
        });
        setTimeout(() => {
            handleFocusOutFunc({
                ...filterData,
                from: value,
            });
        });
    };
    const handleAutocompleteChange2 = (event: any, value: any) => {
        formik.setFieldValue('to', value);
        setFilterData({
            ...filterData,
            to: value,
        });
        setTimeout(() => {
            handleFocusOutFunc({
                ...filterData,
                to: value,
            });
        });
    };

    const validation = yup.object().shape({
        from: yup.object().shape({
            label: yup.string().required(`${t('yup.required')}`),
        }),
        to: yup.object().shape({
            label: yup.string().required(`${t('yup.required')} to`),
        }),
        departureDate: yup.date().required('Zorunlu').min(moment(new Date()).add('day', -1), 'Past'),
    });
    const formik = useFormik<filterDataInterface>({
        initialValues: {
            from: {
                label: '',
                code: '',
                id: '',
            },
            to: {
                label: '',
                code: '',
                id: '',
            },
            departureDate: '',
        },

        onSubmit: async () => {
            sendSearch();
        },
        validationSchema: validation,
    });

    const fetchCallBack = useCallback(async () => {
        const date = moment(new Date()).format('YYYY-MM-DD');

        setFilterData({ ...filterData, departureDate: date });
        if (data?.date !== undefined) {
            if (date === data?.date) {
                setDateButtonIndex(0);
            } else if (moment(date).add(1, 'days').format('YYYY-MM-DD') === data?.date) {
                setDateButtonIndex(1);
            } else {
                setDateButtonIndex(undefined);
            }
        }

        if (data) {
            await getSearch('start', data.from.label);
            await getSearch('end', data.to.label);

            setFilterData({
                ...filterData,
                from: data.from,
            });
            setFilterData({
                ...filterData,
                to: data.to,
            });
            setFilterData({
                ...filterData,
                departureDate: data.date,
            });
        }
    }, [data]);

    const handleClickSubmit = (event: any) => {
        event.preventDefault();
        // setFormChange(true);
        formik.handleSubmit();
    };

    const handleCompareDates = (departureDate: any, selectedDate: any) => {
        const currentDate = dayjs();
        const maxSelectableDate = currentDate.add(365, 'day');
        const selected = dayjs(selectedDate);

        if (departureDate) {
            const minSelectableDate = dayjs(departureDate);
            return selected.isBefore(minSelectableDate) || selected.isAfter(maxSelectableDate);
        }

        return selected.isAfter(maxSelectableDate);
    };

    const popularCodes = [3273, 3274, 1006, 1041, 1020, 1007, 2781, 1032, 3216];

    const getCities = useCallback(async (text: any) => {
        try {
            const response = await searchPopularCities(text);

            const data = response.data.hits.hits ? response.data.hits.hits : [];

            const popularDataList = data
                .map((item: any) => ({
                    label: item._source.ShortName,
                    code: item._source.ID,
                    id: item._id,
                }))
                .filter((tempData: any) => popularCodes.includes(tempData.code))
                .sort((a: any, b: any) => popularCodes.indexOf(a.code) - popularCodes.indexOf(b.code));

            setCities(popularDataList);
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        formik.setFieldValue('from', filterData.from);
        formik.setFieldValue('to', filterData.to);

        formik.setFieldValue('departureDate', filterData.departureDate);
    }, [filterData, setFilterData]);

    useEffect(() => {
        // getCities(popularCodes);

        fetchCallBack();
    }, []);

    return (
        <PageStyled>
            <Grid container spacing={1} className={showDetail ? 'detail-close' : ''}>
                <form onSubmit={handleClickSubmit} className="form-area">
                    <Grid className="custom-grid" item container spacing={1}>
                        <Grid container flex={1} item spacing={1}>
                            <Grid container xs={12} sm={12} md={6} spacing={1} item>
                                <Grid sx={{ position: 'relative' }} xs={12} sm={12} md={6} item>
                                    <Autocomplete
                                        className="right-padding"
                                        value={filterData.from.label}
                                        popupIcon={
                                            <InputAdornment position="end">
                                                <LocationOn style={{ fontSize: 18 }} color="primary" />
                                            </InputAdornment>
                                        }
                                        options={fromData}
                                        filterOptions={(x) => x}
                                        sx={{
                                            [`& .${autocompleteClasses.popupIndicator}`]: {
                                                transform: 'none',
                                            },
                                        }}
                                        onOpen={() => {
                                            cities.length === 0 && getCities(popularCodes);
                                        }}
                                        autoSelect={true}
                                        PaperComponent={(e: any) => {
                                            let tempReturn: any;
                                            fromData.length !== 0
                                                ? (tempReturn = CustomListBox(e))
                                                : (tempReturn = CustomListBox2('start'));

                                            return tempReturn;
                                        }}
                                        onChange={handleAutocompleteChange1}
                                        key={focusIndex}
                                        open={focusIndex === 1 ? true : undefined}
                                        renderInput={(params) => (
                                            <CustomInput
                                                {...params}
                                                type="text"
                                                color="info"
                                                fullWidth
                                                variant="filled"
                                                onChange={(e: any) => {
                                                    getSearch('start', e.target.value);
                                                }}
                                                onBlur={() => {
                                                    setFocusIndex(0);
                                                }}
                                                autoFocus={focusIndex === 1 ? true : undefined}
                                                label={t('bus.widgets.searchBar.from')}
                                                error={formik.touched.from?.label && Boolean(formik.errors.from?.label)}
                                            />
                                        )}
                                        renderOption={CustomList}
                                        disableClearable={true}
                                    />
                                    <IconButton
                                        onClick={() => {
                                            fromToChange(filterData);
                                        }}
                                        className="change-button"
                                        color="inherit"
                                    >
                                        <SwapHoriz />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={12} sm={12} md>
                                    <Autocomplete
                                        className="left-padding"
                                        value={filterData.to.label}
                                        popupIcon={
                                            <InputAdornment position="end">
                                                <LocationOn style={{ fontSize: 18 }} color="primary" />
                                            </InputAdornment>
                                        }
                                        options={toData}
                                        filterOptions={(x) => x}
                                        key={focusIndex}
                                        open={focusIndex === 2 ? true : undefined}
                                        sx={{
                                            [`& .${autocompleteClasses.popupIndicator}`]: {
                                                transform: 'none',
                                            },
                                        }}
                                        autoSelect={true}
                                        // open={true}
                                        onOpen={() => {
                                            cities.length === 0 && getCities(popularCodes);
                                        }}
                                        PaperComponent={(e: any) => {
                                            let tempReturn: any;
                                            toData.length !== 0
                                                ? (tempReturn = CustomListBox(e))
                                                : (tempReturn = CustomListBox2('end'));

                                            return tempReturn;
                                        }}
                                        onChange={handleAutocompleteChange2}
                                        renderInput={(params: any) => (
                                            <CustomInput
                                                {...params}
                                                type="text"
                                                color="info"
                                                fullWidth
                                                variant="filled"
                                                onChange={(e: any) => {
                                                    getSearch('end', e.target.value);
                                                }}
                                                autoFocus={focusIndex === 2 ? true : undefined}
                                                onBlur={() => {
                                                    setFocusIndex(0);
                                                }}
                                                label={t('bus.widgets.searchBar.to')}
                                                error={formik.touched.to?.label && Boolean(formik.errors.to?.label)}
                                            />
                                        )}
                                        renderOption={CustomList}
                                        disableClearable={true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={12} md spacing={1} item>
                                <Grid xs={12} sm={12} md={5} item>
                                    <CustomDatePicker
                                        // type={focusIndex === 4 ? 'flight' : ''}
                                        specialDates={true}
                                        disablePast
                                        shouldDisableDate={(e: any) =>
                                            handleCompareDates(moment(new Date()).format('YYYY-MM-DD'), e)
                                        }
                                        value={filterData.departureDate ? dayjs(filterData.departureDate) : dayjs()}
                                        error={formik.touched.departureDate && !!formik.errors.departureDate}
                                        color="info"
                                        name="departureDate"
                                        variant="filled"
                                        label={t('bus.searchBar.startDate')}
                                        onChange={(e: any) => {
                                            if (!isNaN(e.$D) || e !== null) {
                                                formik.setFieldValue(
                                                    'departureDate',
                                                    moment(e.$d).format('YYYY-MM-DD')
                                                );
                                                if (
                                                    moment(e.$d).format('YYYY-MM-DD') !==
                                                    moment(new Date()).format('YYYY-MM-DD')
                                                ) {
                                                    if (
                                                        moment(new Date()).add(1, 'days').format('YYYY-MM-DD') ===
                                                        moment(e.$d).format('YYYY-MM-DD')
                                                    ) {
                                                        setDateButtonIndex(1);
                                                    } else if (
                                                        moment(e.$d).format('YYYY-MM-DD') ===
                                                        moment(new Date()).format('YYYY-MM-DD')
                                                    ) {
                                                        setDateButtonIndex(0);
                                                    } else {
                                                        setDateButtonIndex(undefined);
                                                    }
                                                } else {
                                                    if (
                                                        moment(e.$d).format('YYYY-MM-DD') ===
                                                        moment(new Date()).format('YYYY-MM-DD')
                                                    ) {
                                                        setDateButtonIndex(0);
                                                    }
                                                }

                                                setFilterData({
                                                    ...filterData,
                                                    departureDate: moment(e.$d).format('YYYY-MM-DD'),
                                                });
                                                // setDefaultCalendarMonth(dayjs(moment(e.$d).format('YYYY-MM-DD')));
                                                setTimeout(() => {
                                                    handleFocusOutFunc({
                                                        ...filterData,
                                                        departureDate: moment(e.$d).format('YYYY-MM-DD'),
                                                    });
                                                });
                                            }
                                        }}
                                        key={focusIndex}
                                        open={focusIndex === 4 ? true : undefined}
                                        onClose={() => {
                                            setFocusIndex(0);
                                        }}
                                        renderInput={(params: any) => (
                                            <CustomInput
                                                {...params}
                                                type="text"
                                                color="info"
                                                fullWidth
                                                variant="filled"
                                                onChange={(e: any) => {
                                                    getSearch('end', e.target.value);
                                                }}
                                                autoFocus={focusIndex === 3 ? true : undefined}
                                                label={t('bus.widgets.searchBar.to')}
                                                error={formik.touched.departureDate && !!formik.errors.departureDate}
                                                helperText={formik.touched.departureDate && formik.errors.departureDate}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid container xs={12} sm={12} md={7} spacing={1} item>
                                    <Grid xs={6} sm={6} md={6} item>
                                        <Button
                                            key={dateButtonIndex}
                                            fullWidth
                                            variant="contained"
                                            endIcon={<CheckCircle />}
                                            sx={{ textTransform: 'none' }}
                                            className={`date-buttons ${dateButtonIndex === 0 && 'active'}`}
                                            color="inherit"
                                            onClick={() => {
                                                setDateButtonIndex(0);

                                                setFilterData({
                                                    ...filterData,
                                                    departureDate: moment(new Date()).format('YYYY-MM-DD'),
                                                });
                                            }}
                                        >
                                            {t('bus.searchBar.today')}
                                        </Button>
                                    </Grid>
                                    <Grid xs={6} sm={6} md={6} item>
                                        <Button
                                            key={dateButtonIndex}
                                            className={`date-buttons ${dateButtonIndex === 1 && 'active'} `}
                                            fullWidth
                                            variant="contained"
                                            color="inherit"
                                            endIcon={<CheckCircle />}
                                            sx={{ textTransform: 'none' }}
                                            onClick={() => {
                                                setDateButtonIndex(1);

                                                setFilterData({
                                                    ...filterData,
                                                    departureDate: moment(new Date())
                                                        .add(1, 'days')
                                                        .format('YYYY-MM-DD'),
                                                });
                                            }}
                                        >
                                            {t('bus.searchBar.tomorrow')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Button
                                fullWidth
                                sx={{
                                    height: '56px',
                                    fontSize: 14,
                                    gap: 1,
                                }}
                                variant="contained"
                                size="large"
                                color="secondary"
                                // onClick={sendSearch}
                                id={`gtm-bus-${gtm}-search-button`}
                                type="submit"
                            >
                                {media.width <= 900
                                    ? showDetail
                                        ? t('button.busSearchAgainButton')
                                        : t('button.busSearch')
                                    : ''}

                                <Search />
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </PageStyled>
    );
};

export default BusSearchBar;
